import classnames from 'classnames';
import React, { useCallback } from 'react';
import { IoMdClose as CloseIcon } from 'react-icons/io';
import { MdCreate as PenIcon } from 'react-icons/md';
import { createUseStyles } from 'react-jss';
import { useDispatch, useSelector } from 'react-redux';

import { toggleEditMode } from '../../redux/actions';

const useStyles = createUseStyles({
  button: {
    '&.editmode': { background: '#FF5A50' },
    '&.editmode:hover': { background: '#3CBC76' },
    '&:hover': { background: '#FF5A50' },
    background: '#3CBC76',
    borderRadius: 24,
    boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.45)',
    color: '#FFFFFF !important',
    composes: ['is-block', 'no-overflow', 'mt6'],
    height: 48,
    width: 48,
  },
  icon: {
    verticalAlign: 'middle',
  },
});

const AdminButtonComponent = React.memo(() => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const editmode = useSelector(_ => _.editMode);

  const clickAdminMode = useCallback(() => {
    dispatch(toggleEditMode());
  }, [dispatch]);

  return (
    <button
      className={classnames(classes.button, { editmode })}
      type="button"
      onClick={clickAdminMode}>
      {!editmode && <PenIcon size={24} />}
      {editmode && <CloseIcon size={24} />}
    </button>
  );
});

AdminButtonComponent.displayName = 'AdminButtonComponent';

export default AdminButtonComponent;
